<span
  [class]="getClasses()"
  [style]="{ maxWidth: maxWidth() }"
  [attr.role]="ariaRole()"
  [attr.aria-label]="getAriaLabel()"
  ftrTooltip
  [message]="getTooltipLabel()"
  [position]="tooltipPosition()"
  [alignment]="tooltipAlignment()"
  [forceDisplayState]="!!getTooltipLabel() ? undefined : 'hide'"
  [showDash]="false"
>
  @if (icon() && displayType() !== 'small') {
    <ftr-icon class="badge__icon" [icon]="icon()!" size="Text" />
  }
  @if (text() && displayType() !== 'tile') {
    <span [attr.aria-hidden]="!!getAriaLabel() ? true : undefined" class="badge__text">{{ text() }}</span>
  }
</span>
